<template>
  <div>
    <div class="d-flex align-center py-3">
      <h2 class="flex-grow-1">Conditions</h2>
      <v-btn color="primary" small @click="addCondition">Add Condition</v-btn>
    </div>

    <v-simple-table>
      <thead>
        <tr>
          <th>Result Page</th>
          <th>Min</th>
          <th>Max</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in conditions" :key="index">
          <td>
            <v-select
              :items="resultPages"
              item-text="title.th"
              item-value="id"
              v-model="row.id"
              dense
              outlined
              hide-details
              label="Select Result Page"
            />
          </td>
          <td>
            <v-text-field v-model.number="row.range.min" dense outlined type="number" hide-details />
          </td>
          <td>
            <v-text-field v-model.number="row.range.max" dense outlined type="number" hide-details />
          </td>
          <td>
            <v-btn icon color="error" @click="removeCondition(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <!-- Save Button -->
    <v-row justify="end" class="mt-4">
      <v-btn color="primary" small @click="save">Save Conditions</v-btn>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    resultPages: { type: Array, required: true },
    conditions: { type: Array, default: () => [] },
    assessmentId: { type: Number, required: true },
  },
  methods: {
    addCondition() {
      this.conditions.push({ id: null, range: { min: 0, max: 0 } });
    },
    removeCondition(index) {
      this.conditions.splice(index, 1);
    },
    save() {
      this.$emit('onSave', this.assessmentId, this.conditions);
    },
  },
};
</script>
